import React from "react";
// import { Bar } from "react-chartjs-2";
// import {
//     Chart as ChartJS,
//     CategoryScale,
//     LinearScale,
//     BarElement,
//     Title,
//     Tooltip,
//     Legend,
// } from 'chart.js';
// import ChartDataLabels from 'chartjs-plugin-datalabels';
import { forwardRef } from "react";

// ChartJS.register(
//     CategoryScale,
//     LinearScale,
//     BarElement,
//     Title,
//     Tooltip,
//     Legend,
//     ChartDataLabels
// );

// const GraphComponent = forwardRef(({nameKey='name', name = '', tableName = "Clinic", chartData=[] ,total={}}, ref) => {
const GraphComponent = forwardRef(({nameKey='name', name = '', tableName = "Clinic", chartData=[] ,total=''}, ref) => {
    return (
        <div className="mt-8  p-4 rounded is-drop-when-no-space" style={{ background: '#f1f4f9' }}>
            <div className="d-flex justify-content-between w-full align-items-center">
                <h5>
                    
                    {name}
                </h5>

                <div>
                    <div className="badge me-2" style={{
                        backgroundColor: "#fff2cb", color: '#555', paddingTop: 6,
                        height: 50, width: 100
                    }}>
                        <h6>{total?.total || 0}</h6>
                        <span>Referred</span>
                    </div>
                    <div className="badge me-2" style={{
                        backgroundColor: "#d6f0fb", color: '#555', paddingTop: 6,
                        height: 50, width: 100
                    }}>
                        <h6>{total?.onboardedUser || 0}</h6>
                        <span>Onboarded</span>
                    </div>
                    <span className="badge  me-2" style={{
                        backgroundColor: "#d8cdfb", color: '#555', paddingTop: 6,
                        height: 50, width: 100
                    }}>
                        <h6>{total?.active || 0}</h6>
                        <span>Active</span>
                    </span>
                    <span className="badge  me-2" style={{
                        backgroundColor: "#e0fbd6", color: '#555', paddingTop: 6,
                        height: 50, width: 100
                    }}>
                        <h6>{total?.inactive || 0}</h6>
                        <span>Inactive</span>
                    </span>
                    <span className="badge " style={{
                        backgroundColor: "#fbd7d6", color: '#555', paddingTop: 6,
                        height: 50, width: 100
                    }}>
                        
                        <h6>{total?.percentage || 0}</h6>
                        <span>% Active</span>
                    </span>
                </div>
            </div>
            <table className="table table-bordered mt-6 bg-white shadow table_border remove_strap">
                        <thead className="custom-header" >
                            <tr>
                                <th>{tableName}</th>
                                <th>Referred</th>
                                <th>Onboarded</th>
                                <th>Active</th>
                                <th>Inactive</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                chartData?.map((val, index) => (
                                    <tr key={`${tableName}_${index}`}>
                                        <td>{val?.[nameKey]}</td>
                                        <td>{val?.total}</td>
                                        <td>{val.onboardedUser}</td>
                                        <td>{val.active}</td>
                                        <td>{val.inactive}</td>
                                    </tr>
                                ))
                            }

                        </tbody>
                    </table>
            {/* <div className="card shadow-sm mt-4">
                <div className="card-body">
                    
                    <Bar ref={ref} data={chartData} options={options} plugins={[ChartDataLabels]} />
                </div>
            </div> */}
        </div>
    );
});
export default GraphComponent;
